import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Directive, ElementRef, Input, OnChanges, OnInit, Pipe, PipeTransform, Renderer2, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SpinnerService } from 'src/app/components/spinner-component/spinner.service';
import { RestService } from 'src/app/services/rest-service';
import { AppSettings } from 'src/app/shared/app-settings';
import { Title } from '@angular/platform-browser';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ConfigService } from 'src/app/services/config.service';
import { catchError, tap } from 'rxjs/operators';

declare const myTest: any;
declare const onmouse: any;

@Pipe({ name: 'safe', standalone: false })
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }
  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}

@Component({
  selector: 'app-site-details',
  templateUrl: './site-details.component.html',
  styleUrls: ['./site-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
,
  standalone: false
})

export class SiteDetailsComponent implements OnInit,OnChanges {
  @ViewChild('chartContainer', { static: false }) chartContainer: ElementRef;
  @ViewChild('tabGroup') tabGroup;
  @ViewChild('siteTabGroup') siteTabGroup;
  @Input() deviceInfoDataObj:any;
  @Input() cameraMeta:any;
  @Input() cameraMetadata:any;
  @Input() mdcMetadata:any;
  @Input() routerInfo:any;
  isperformanceEnabled:boolean = false;
  zoom = 1;
  noData = true;
  url: string;
  camurls: String[];
  site: any;
  cams: any;
  fromDate: any;
  toDate: any;
  weatherFromDt: any;
  step: any;
  labelName: string;
  sitetablabel: any;
  chartColors: any[] = [{ backgroundColor: ["#13c728", "#f26b5b", "#f0fd21"] }];
  camUpCount: number = 0;
  camDownCount: number = 0;
  alarmUpCount: number = 0;
  alarmDownCount: number = 0;
  otherUpCount: number = 0;
  otherDownCount: number = 0;
  camCount: number = 0;
  AlarmCount: number = 0;
  otherCount: number = 0;
  grafanaData: any;
  data:any;
  isGraphLoaded = false;
  networkData: any;
  switchData = [];
  current_IP: string;
  networkResponse: any;
  scanResults: any;
  ipData: any[];
  totaldevice: number;
  totalUpDeviceCount: number;
  percentageUpDevice: number;
  totalDownDeviceCount: number;
  percentageDownDevice: number;
  solar: boolean = false;
  public ascDsc: boolean = true;
  loading: boolean = false;
  roundedTemp: string;
  state_weather: string;
  city_weather: string;
  weather_categ: any;
  icons_display: string="";
  showWeatherDiv: boolean=false;
  show: boolean = false;
  masking_cameradayImg: any;
  masking_nightimage: any;
  camName: string;
  start: any;
  end: any;
  public disabled = false;
  public showSpinners = true;
  public showSeconds = true;
  public touchUi = false;
  public enableMeridian = false;
  public stepHour = 1;
  public stepMinute = 1;
  public stepSecond = 1;
  public color: ThemePalette = 'primary';
  public disableMinute = false;
  public hideTime = false;
  public filteredMonitorsData: Array<any> = [];
  filterValue: any = "1";
  hdOrSd: any;
  manualSync: string;
  msync: Object;
  sitesData: any;
  devicesData: any;
  siteData: any;
  siteId: any;
  accName: string;
  analyticId:number;
  toDateCustom: Date;
  fromDateCustom: Date;
  buttonDisabled = false;
  monitoringHoursData: any;
  is24Hours: boolean = false;
  results: any = [];
  responseData: string;
  dataBeforeEdit:string;
  mdcScript: any;
  form: FormGroup;
  isEditing: boolean = false;
  editSolarScript: boolean = false;
  devicetype: any;
  x310url: string;
  showScript: string = "show_script";
  showPreview: boolean = true;
  updateScript: boolean = true;
  selectedTab: number;
  selectedScript: string = '';
  isModalOpen = false;
  devPort: any;
  notEdited=false;
  currentUser:any;
  username:string;
  x410url: string;
  devPort1: any;
  odroidPort:any;
  x310IP: string;
  x410IP: string;
  odroidIP: string;
  startTime: string;
  endTime: string;
  initialStartTime: any;
  initialEndTime: any;
  initialCheckdays: any;
  checkDays: string;
  editClicked = true;
  previewResponse: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  previewResponse$ = this.previewResponse.asObservable();
  updateData: any;
  checkDay: any;
  precheckDay: any;
  preStartTime: any;
  preEndTime: any;
  previewClick: boolean = false;
  scripthistory: any;
  lastModifiedBy: string;
  lastModifiedAt: string;
  source: any;
  mdcScript1: any;
  dropdownChanged: boolean = false;
  loader = true;
  thistoryData: Array<any> = [];
  selectedScript1: any;
  basicResponse: any;
  popupVisible = false;
  deviceNames: any;
  deviceStatus: any;
  ticket: any;
  ticketLink: any;
  isChecked: boolean;
  isCheckedDelay: boolean = false;
  initialDelayflag: boolean;
  delayFlag: boolean;
  
  transformedSchedule: any;
  previewMDCresponse: any;
  weekdaysObj: any[] = [];
  mdcPayload: any;
  mdc_url: string;
  mdc_preData: any;
  days: string[] = [];
  orderedSchedule = {};
  scheduleTimes: any;
  inputTimes: any = {};
  backupPreData: any;
  morningStart: Date;
  morningEnd: Date;
  eveningStart: Date;
  eveningEnd: Date;
  checked = false;
  requestData: any;
  initialMDCresponse: any;
  initialMDXresponse: any;
  originalValues: any = {};
  checkboxStates: {[key: string]: boolean} = {};
  rainData: string;
  forecastWeather: string;
  forcastDays: string;
  forcastTemp: string;
  temperature: number;
  weatherDetails: any;
  startDays: any;
  endDays: any;
  startTimes: any;
  endTimes: any;
  orderedDays: string[] = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  showRouterData : boolean = false;
  showMdcModeldata : boolean = false;
  showCameraModelData : boolean = false;
  inspectionTypes: any[] = [
  {inspection_type_id: 1, description: '5'},
  {inspection_type_id: 2, description: '6'},
  {inspection_type_id: 3, description: '7'}
  ];
  oppotunityStageMessage: string = "";
  scheduledInstallDate: any;
  isFilter:boolean = false;
  
  constructor(
  public spinner: SpinnerService,
  private toastr: ToastrService,
  public restService: RestService,
  private router: Router,
  private activatedroute: ActivatedRoute,
  private sanitizer: DomSanitizer,
  private hostElement: ElementRef,
  private titleService: Title,
  public http: HttpClient,
  public authService: AuthenticationService,
  private cdr: ChangeDetectorRef,
  public configService: ConfigService
  ) {
    this.titleService.setTitle("Sites Details");
    this.activatedroute.params.subscribe(params => {
      this.site=params.id
    })
    
    this.isGraphLoaded = false;
    const epochTo = (new Date()).getTime();
    const epochFrom = epochTo - 1000 * 60 * 60 * 24;
    const epochFrom1 = epochTo - 1000 * 60 * 60;
    this.toDate = epochTo;
    this.fromDate = epochFrom;
    this.weatherFromDt = epochFrom1;
    
    this.step = "1h";
    this.site = this.router.getCurrentNavigation().extras?.state?.site;
    this.siteId = this.site?.siteId;
    this.analyticId = this.site?.analyticId;
    this.accName = this.site?.accName;
    this.current_IP = this.site?.ipaddress;
    this.hdOrSd = this.site?.hdOrSd;
    this.grafanaData = this.router.getCurrentNavigation().extras?.state?.grafana;
    if(!this.grafanaData && !this.site && !this.current_IP && !this.hdOrSd && !this.accName && !this.siteId){
      let siteSelectedDataFromLS = JSON.parse(localStorage.getItem('selectedSiteObj'));
      this.site = siteSelectedDataFromLS.site;
      this.grafanaData = siteSelectedDataFromLS.gafana;
      this.current_IP = this.site?.ipaddress;
      this.hdOrSd = this.site?.hdOrSd;
      this.accName = this.site?.accName;
      this.siteId = this.site?.siteId;
    }
    // this.url = 'https://dev-grafana.pro-vigil.info:3000/d-solo/avszAyAnk/profit-sites?orgId=1&refresh=' + this.step + '&from=' + this.fromDate + '&to=' + this.toDate + '&var-job=Pushgateway&var-name=' + this.site.siteId + '&panelId=2';
    this.url = this.grafanaData.sitesUrl + this.step + '&from=' + this.fromDate + '&to=' + this.toDate + '&var-job=Pushgateway&var-name=' + this.site.siteId + `&panelId=${environment.env == 'uat' ? 1 : 2}`;
    this.cams = this.site.devices;
    
    document.addEventListener('dblclick', function (event) {
      event.preventDefault();
      event.stopPropagation();
    }, true
    );
    
    this.orderedDays?.forEach(day => {
      if (this.mdc_preData) {
        this.orderedSchedule[day] = this.mdc_preData[day] || [];
      } else {
        this.orderedSchedule[day] = [];
      }
    });
    
    if (!this.mdcScript1) {
      this.orderedDays.forEach(day => {
        this.inputTimes[day] = {
          morningStart: null,
          morningEnd: null,
          eveningStart: null,
          eveningEnd: null
        };
      });
    }
  }
  
  ngOnInit(): void {
    this.getCurrentUser()
    this.stageMessage()
    this.rootChart()
    this.deviceType()
    this.scriptFlag()
    this.scriptHistory()
    this.lastChange()
    this.getTicketHistory()
    this.getMonitoringHours()
    this.getWeatherForcast()
    
    for (const cam of this.cams) {
      if (cam.deviceType == "Camera") {
        this.camCount++;
        if (cam.status == "Up") {
          this.camUpCount++;
        }
        else {
          this.camDownCount++;
        }
      }
      if (cam.deviceType == "Alarm") {
        this.AlarmCount++;
        if (cam.status == "Up") {
          this.alarmUpCount++;
        }
        else {
          this.alarmDownCount++;
        }
      }
      if (cam.deviceType == "Other") {
        this.otherCount++;
        if (cam.status == "Up") {
          this.otherUpCount++;
        }
        else {
          this.otherDownCount++;
        }
      }
      
    }
    this.totalUpDeviceCount = this.camUpCount + this.alarmUpCount + this.otherUpCount;
    this.totalDownDeviceCount = this.camDownCount + this.alarmDownCount + this.otherDownCount;
    this.totaldevice = this.camCount + this.AlarmCount + this.otherCount;
    let TUDC =  this.totalUpDeviceCount;
    let TDDC = this.totalDownDeviceCount;
    let TD = this.totaldevice;
    let c = (TDDC/TD);
    let d = c;
    this.percentageDownDevice = d;
    this.getWeatherdata();
    this.cdr.detectChanges();
    let title = this.titleService.getTitle();
    
    const isButtonDisabled = localStorage.getItem('buttonDisabled');
    this.buttonDisabled = isButtonDisabled === 'true';
    if (this.buttonDisabled) {
      this.buttonDisabled = false;
      // Clear the stored state in local storage
      localStorage.removeItem('buttonDisabled');
    }
    this.days = Object.keys(this.mdc_preData);
  }
  
  getCurrentUser() {
    this.currentUser = this.authService.currentUserValue;
    if (this.currentUser) {
      this.username = this.currentUser.firstName;
      if (this.currentUser['privileges'] && this.currentUser['privileges'].length > 0) {
        for (let i = 0; i < this.currentUser['privileges'].length; i++) {
          if (this.currentUser['privileges'][i].toLowerCase() === 'edit solar script') {
            this.editSolarScript = true;
          }
        }
      }
    }
  }

  stageMessage(){
    if (this.site.stage == "-"){
      this.oppotunityStageMessage = `(Health Monitoring Not Yet Activated- Opportunity stage  is Not Contain)`
    } else if (this.site.stage != "Installed" && this.site.stage != "-"){
      this.oppotunityStageMessage = `(Health Monitoring Not Yet Activated- Opportunity stage  is '${this.site.stage}')`
    }   
  }
  
  rootChart() {
    if (this.current_IP != null || this.current_IP != undefined) {
      const url = AppSettings.COMPARED + this.current_IP;
      this.spinner.activate();
      this.loading = true;
      
      this.restService.getRequest(url, '').subscribe((response) => {
        if (response.hasOwnProperty('data') && response.data !== null) {
          this.networkResponse = response;
          
          if (this.networkResponse.success) {
            this.networkData = this.networkResponse.data.scanResults;
            this.noData = false;
            this.loader = true;
          } else {
            this.noData = true;
            this.loader = false;
          }
          
          this.data = {
            fname: '',
            lname: '',
            title: '',
            photo: './assets/imgs/expand.png',
            imgname: 'rootChart',
            children: this.getSwitchData()
          };
          
          this.spinner.deactivate();
          this.loading = false;
        } else {
          this.loading = false;
          this.toastr.error('Data not found');
        }
      });
    }
  }
  
  getSwitchData() {
    if (this.networkData !== undefined || this.networkData !== null) {
      let sortedData = this.sortData(this.networkData);
      
      if (sortedData !== undefined && sortedData !== null) {
        for (let i = 0; i < sortedData.length; i++) {
          let img = this.getImages(sortedData[i].device_type, sortedData[i].tunnel_forwarding_port);
          let childData = {
            deviceName: sortedData[i].deviceName ? sortedData[i].deviceName : null,
            // status: sortedData[i].changed_status == "CONNECTED" ? './assets/imgs/online.png' : sortedData[i].changed_status == "DISCONNECTED" ? './assets/imgs/offline.png' : null,
            fname: sortedData[i].model,
            lname: ' ',
            title: sortedData[i].ip_address,
            title1: sortedData[i].mac_address,
            photo: img,
            imgname: "switch" + img + i,
            children: this.getPorts(sortedData[i], i),
            onmouseData: {
              Device_type: sortedData[i].device_type,
              Device_Name: sortedData[i].deviceName ? sortedData[i].deviceName : '',
              DeviceUqId: sortedData[i].deviceUqId ? sortedData[i].deviceUqId : '',
              Firmware: sortedData[i].firmware,
              Ip_address: sortedData[i].ip_address,
              Mac_address: sortedData[i].mac_address,
              Model: sortedData[i].model,
              Parent_Ip_address: sortedData[i].parent_ip_address,
              Snmp_enabled: sortedData[i].snmp_enabled,
              Snmp_version: sortedData[i].snmp_version,
              Tunnel_forwarding_port: sortedData[i].tunnel_forwarding_port,
              Tunnel_Ip: sortedData[i].tunnel_ip,
              Up_time: sortedData[i].up_time
            }
          };
          
          this.switchData.push(childData);
        }
      }
      return this.switchData;
    } else {
      this.toastr.error('Data not found');
    }
  }
  
  
  getPorts(childData, switchCount) {
    let portsData = [];
    let portData = childData.show_interface_status ? childData.show_interface_status : null;
    
    if (portData == null) {
      return null;
    } else {
      for (let i = 0; i < portData.length; i++) {
        let param;
        if (portData[i].child_device == null || portData[i].child_device == undefined || portData[i].child_device.child_device_type == "unknown") {
          if (portData[i].mac_address_table_interface && portData[i].mac_address_table_interface.length > 0) {
            param = null;
          } else {
            param = 'NOIMAGE';
          }
        } else {
          param = portData[i].child_device && portData[i].child_device.child_device_type || null;
        }
        
        let ipData;
        let ip = [];
        if (portData[i].child_device && portData[i].child_device.child_ip_address) {
          let ipAddress = portData[i].child_device.child_ip_address;
          ipData = this.networkData.find(ele => ele.ip_address == ipAddress);
        }
        ip.push(ipData);
        
        let port = {
          // status: ipData?.changed_status == "CONNECTED" ? './assets/imgs/online.png' : ipData?.changed_status == "DISCONNECTED" ? './assets/imgs/offline.png' : null,
          deviceName: ipData?.deviceName,
          fname: portData[i].port,
          lname: '',
          title: ipData?.model || ipData?.device_type || "",
          title1: ipData?.ip_address || "",
          title2: ipData?.mac_address || "",
          photo: this.getImages(param, ipData?.tunnel_forwarding_port || 0),
          imgname: 'port' + switchCount + "_" + i,
          children: this.getCBdata(ipData),
          onmouseData: this.generateMouseData(portData[i], ipData)
        };
        portsData.push(port);
      }
      return portsData;
    }
  }
  
  
  sortData(data) {
    if (data !== null && data !== undefined) {
      let sortedData = [];
      let switchWithChildData = data.filter(ele => ele.parent_ip_address != null && ele.device_type === 'switch' && ele.show_interface_status != null);
      let switchWithChildData1 = data.filter(ele => ele.parent_ip_address == null && ele.device_type === 'switch' && ele.show_interface_status != null);
      
      let switchWithoutChildData = data.filter(ele => ele.parent_ip_address !== null && ele.device_type === 'switch' && ele.show_interface_status == null);
      let switchWithoutChildData1 = data.filter(ele => ele.parent_ip_address == null && ele.device_type === 'switch' && ele.show_interface_status == null);
      let cameraData = data.filter(ele => ele.parent_ip_address == null && ele.device_type === 'camera');
      let speakerData = data.filter(ele => ele.parent_ip_address == null && ele.device_type === 'speaker');
      let wirelessData = data.filter(ele => ele.parent_ip_address == null && ele.device_type === 'wireless_access_point');
      let cradlepoint = data.filter(ele => ele.parent_ip_address == null && ele.device_type === 'router');
      let cradlepoint1 = data.filter(ele => ele.parent_ip_address != null && ele.device_type === 'router');
      let unknownData = data.filter(ele => ele.parent_ip_address == null && ele.device_type === 'unknown');
      
      sortedData = sortedData.concat(switchWithChildData, switchWithChildData1, switchWithoutChildData, switchWithoutChildData1, cameraData, speakerData, wirelessData, cradlepoint, cradlepoint1, unknownData);
      return sortedData;
    }
  }
  
  
  getMacAdd(portData) {
    let macArray = [];
    let macData = portData.mac_address_table_interface ? portData.mac_address_table_interface : null;
    
    if (macData == null) {
      return null;
    } else {
      for (let i = 0; i < macData.length; i++) {
        let mac = {
          fname: macData[i],
          lname: '',
          title: '',
          photo: './assets/imgs/mac2.png',
          imgname: 'mac' + i,
          children: null
        };
        macArray.push(mac);
      }
      return macArray;
    }
  }
  
  
  getImages(device_type, tunnel_forwarding_port, portId = null) {
    let imgPath = '';
    if (device_type == 'switch') {
      imgPath = './assets/imgs/Aetek-Switch.png';
    } else if (device_type == 'camera') {
      imgPath = './assets/imgs/AXIS-M2025-LE-Network-Camera.png';
    } else if (device_type == 'speaker') {
      imgPath = './assets/imgs/AXIS-C3003-E-Network-Horn-Speaker.png';
    } else if (device_type == 'wireless_access_point') {
      imgPath = './assets/imgs/Wireless-Access-Point.png';
    } else if (device_type == 'router') {
      imgPath = './assets/imgs/cradlepoint-router.png';
    } else if (device_type == null) {
      imgPath = './assets/imgs/question.png';
    } else {
      imgPath = './assets/imgs/cancel.png';
    }
    return imgPath;
  }
  
  
  getCBdata(ipData) {
    let CBarray = [];
    let CBdata = ipData?.wireless_info?.connected_wireless_devices ? ipData?.wireless_info?.connected_wireless_devices : null;
    
    if (CBdata == null) {
      return null;
    } else {
      for (let i = 0; i < CBdata.length; i++) {
        let cb = {
          // status: ipData.changed_status == "CONNECTED" ? './assets/imgs/online.png' : ipData.changed_status == "DISCONNECTED" ? './assets/imgs/offline.png' : null,
          fname: CBdata[i].connected_device_model,
          lname: '',
          title: CBdata[i].connected_device_ip_address,
          title1: CBdata[i].mac_address,
          title2: '',
          photo: './assets/imgs/Wireless-Access-Point.png',
          imgname: 'cb' + i,
          children: null,
          onmouseData: {
            DeviceName: ipData?.wireless_info?.connected_wireless_devices[i]?.connected_device_model || "",
            Ip_address: ipData?.wireless_info?.connected_wireless_devices[i]?.connected_device_ip_address || "",
            Mac_address: ipData?.wireless_info?.connected_wireless_devices[i]?.mac_address || "",
          }
        };
        CBarray.push(cb);
      }
      return CBarray;
    }
  }
  
  generateCBData(ipData) {
    let data = {
      DeviceName: ipData?.wireless_info?.connected_device_model || "",
      Ip_address: ipData?.wireless_info?.connected_device_ip_address || "",
      Mac_address: ipData?.wireless_info?.mac_address || "",
      Up_time: ''
    };
    return data;
  }
  
  
  getMouseData(portData, ipData) {
    let data;
    if (ipData && ipData.deviceName) {
      data = this.generateMouseData(portData, ipData);
    } else if (ipData && ipData.deviceName == null) {
      if (ipData.device_type && ipData.device_type == "wireless_access_point") {
        data = this.generateMouseData(portData, ipData);
      } else {
        data = null;
      }
    } else {
      data = null;
    }
    return data;
  }
  
  generateMouseData(portData, ipData) {
    let data = {
      Port: portData.port,
      DeviceName: ipData?.deviceName || ipData?.device_type || "",
      DeviceUqId: ipData?.deviceUqId || "",
      AnalyticId: ipData?.analyticId || "",
      Ip_address: ipData?.ip_address || "",
      Mac_address: ipData?.mac_address || "",
      Tunnel_forwarding_port: ipData?.tunnel_forwarding_port || "",
      Tunnel_ip: ipData?.tunnel_ip,
      Model: ipData?.model || "",
      Up_time: ipData?.up_time || ""
    };
    return data;
  }
  
  
  getWeatherdata() {
    this.showWeatherDiv = false;
    let sitePotentialId = this.site.potentialId;
    let url = AppSettings.WEATHER + sitePotentialId;
    
    try {
      this.restService.getWeather(url).subscribe((response) => {
        this.weatherDetails = response.data
        this.rainData = response.data.weather[0].main
        if (this.weatherDetails.name !=null && this.weatherDetails.state !=null && this.weatherDetails?.main?.temp !=null &&
          this.weatherDetails?.weather[0]?.description !=null && this.weatherDetails.weather[0]?.main !=null) {
          this.showWeatherDiv = true;
          let temp = parseFloat(this.weatherDetails?.main?.temp);
          this.roundedTemp = Math.round(temp) + '°F ';
          this.state_weather = ' ' + this.weatherDetails.state;
          this.city_weather = ' ' + this.weatherDetails.name;
          this.weather_categ = this.weatherDetails.weather[0].main;
          this.temperature = Math.round(temp);
          this.cdr.detectChanges();
          
          switch (this.weather_categ) {
            case "Clouds":
            this.icons_display = 'assets/images/svg/Cloud.gif';
            break;
            case "Clear":
            this.icons_display = 'assets/images/svg/Clear.gif';
            break;
            case "Mist":
            this.icons_display = 'assets/images/svg/mist_new.gif';
            break;
            case "Fog":
            this.icons_display = 'assets/images/svg/Fog.gif';
            break;
            case "Rain":
            this.icons_display = 'assets/images/svg/new_Rain.gif';
            break;
            case "Snow":
            this.icons_display = 'assets/images/svg/Snow.gif';
            break;
            case "Smoke":
            this.icons_display = 'assets/images/svg/Haze.svg';
            break;
            case "Drizzle":
            this.icons_display = 'assets/images/svg/Drizzle.svg';
            break;
          }
        } else {
          this.showWeatherDiv = false;
          this.icons_display = '';
          this.roundedTemp = '';
          this.city_weather = '';
          this.weather_categ = '';
          this.state_weather = '';
        }
        this.cdr.detectChanges();
      }, (error: any) => {
      });
    } catch (err) {
    }
  }
  
  
  sync() {
    this.spinner.activate();
    this.manualSync = AppSettings.API_ENDPOINT + '/' + AppSettings.MANUAL_SYNC + this.site.potentialId;
    this.http.get(this.manualSync, { responseType: 'text' }).subscribe((dt) => {
      if (dt === 'success') {
        const site = this.site.potentialId;
        this.router.navigateByUrl(`sites/${site}`);
      } else {
        this.toastr.error('Unable to Sync now. Please try after some time.');
      }
      this.spinner.deactivate();
    }, (error) => {
      this.toastr.error(error);
      this.spinner.deactivate();
    });
    
    this.buttonDisabled = true;
    // Store the state in local storage
    localStorage.setItem('buttonDisabled', 'true');
  }
  
  
  getMonitoringHours() {
    let monitoringHours = AppSettings.MONITORING_HOURS + this.site.potentialId;
    this.restService.getRequest(monitoringHours, '').subscribe((response) => {
      if (response != undefined || response != null) {
        this.monitoringHoursData = response.monitoringHours;
        this.formatMonitoringHours(this.monitoringHoursData);
      }
    });
  }
  
  
  formatMonitoringHours(data: any) {
    let tmpArray: any = [];
    if (data) {
      data.reduce((acc: any, element: any, index: any, sourceArray: any) => {
        let weekDay = element.WeekofDay;
        if (tmpArray.indexOf(element.WeekofDay) === -1) {
          tmpArray.push(element.WeekofDay);
          
          let twenty4Hrs = 'No';
          this.is24Hours = true;
          let result = sourceArray.filter((ele: any) => {
            if (ele.WeekofDay === element.WeekofDay) {
              let startTime = ele.MonitoringHours.split('-')[0];
              let endTime = ele.MonitoringHours.split('-')[1];
              if ((startTime.trim() === '00:00 AM' && endTime.trim() === '23:59 PM')
              || (startTime.trim() === '00:00 AM' && endTime.trim() === '11:59 AM')
              || (startTime.trim() === '12:00 PM' && endTime.trim() === '23:59 PM')) {
                twenty4Hrs = 'Yes';
                this.is24Hours = true;
              } else {
                this.is24Hours = false;
              }
            }
            return ele.WeekofDay === element.WeekofDay;
          });
          this.results.push({ weekDay, result, twenty4Hrs });
          return result;
        } else {
          return acc;
        }
      }, []);
    }
    return this.results;
  }
  
  
  generateScript() {
    if (this.selectedScript1 === '1') {
      this.installBasicGenerate();
    } else if (this.selectedScript1 === '2') {
      this.updateGenerate();
    }
  }
  
  
  mainUpdate() {
    if (this.selectedScript1 === '1') {
      this.installBasic();
    } else if (this.selectedScript1 === '2') {
      this.update();
    }
  }
  
  
  installBasic() {
    if (this.editSolarScript && (this.source.toUpperCase() !== 'DATABASE' || this.site.status == 'Not Monitoring')) {
      this.previewClick = true;
      this.showScript = 'preview_script';
      let user = this.authService?.currentUserSubject?.value?.email;
      let selectedValue = encodeURIComponent(this.precheckDay);
      this.url = `${AppSettings.API_ENDPOINT}/${AppSettings.GENERATE_SCRIPT}${this.site.potentialId}&deviceType=${this.devicetype}&createdby=${user}&scriptType=basic&startTime='00:00:00'&endTime='23:59:59'&chckday='7'`;
      this.http.get(this.url, { responseType: 'text' }).subscribe((response: any) => {
        this.previewResponse.next(response);
      }, (error) => {
        this.toastr.error('Please try again');
      });
      this.cdr.detectChanges();
    } else if (this.source.toUpperCase() == 'DATABASE') {
      this.toastr.error('Please access when the device is back online');
    }
  }
  
  
  update() {
    if ((this.editSolarScript && (this.source.toUpperCase() !== 'DATABASE' || this.site.status == 'Not Monitoring'))) {
      this.showScript = 'update_script';
      const updateScript = `${AppSettings.PRE_POPULATE}`;
      
      // Fetch data from local storage if not set
      if (!this.precheckDay && !this.preStartTime && !this.preEndTime && !this.delayFlag) {
        this.precheckDay = localStorage.getItem('precheckDay') || '';
        this.preStartTime = localStorage.getItem('preStartTime') || '';
        this.preEndTime = localStorage.getItem('preEndTime') || '';
        this.delayFlag = localStorage.getItem('delayFlag') === 'true' || false;
      }
      
      const formData = new FormData();
      formData.append('script', new Blob([this.responseData], { type: 'text/plain' }), 'script.txt');
      formData.append('deviceType', this.devicetype);
      const linesToCheck = "LET t1 = 72000";
      this.delayFlag = this.responseData?.includes(linesToCheck.trim());
      
      this.restService.postRequest(updateScript, formData).subscribe((data: any) => {
        if (!data) {
          return;
        }
        // Update class properties and store in local storage
        this.updateData = data;
        this.precheckDay = this.updateData.CheckDay;
        this.preStartTime = this.formattime(this.updateData.StartTime);
        this.preEndTime = this.formattime(this.updateData.EndTime);
        
        this.initialStartTime = this.preStartTime;
        this.initialEndTime = this.preEndTime;
        this.initialCheckdays = this.precheckDay;
        this.initialDelayflag = this.delayFlag;
        
        localStorage.setItem('updateData', JSON.stringify(this.updateData));
        localStorage.setItem('precheckDay', this.precheckDay);
        localStorage.setItem('preStartTime', this.preStartTime);
        localStorage.setItem('preEndTime', this.preEndTime);
        localStorage.setItem('delayFlag', this.delayFlag.toString());
        
        this.cdr.detectChanges();
      }, error => {
        
      });
    } else if (this.source.toUpperCase() == 'DATABASE') {
      this.toastr.error('Please access when the device is back online');
    }
  }
  
  getMdxScript() {
    let user = this.authService.currentUserSubject.value.email;
    let url = `${AppSettings.API_ENDPOINT}/${AppSettings.SCRIPT}${this.site.potentialId}&viewedby=${user}`;
    
    this.http.get(url, { responseType: 'text' }).subscribe((response: any) => {
      if (response) {
        if (typeof(response) == "string") {
          response = JSON.parse(response);
        }
        this.responseData = response[0];
        this.initialMDXresponse = this.responseData
        this.source = response[1];
        this.solarSummary(this.responseData)
      }
    }, (error) => {
      this.toastr.error('Data not found');
    });
    
    this.cdr.detectChanges();
  }
  
  getMdcScript() {
    let user = this.authService.currentUserSubject.value.email;
    let url = `${AppSettings.API_ENDPOINT}/${AppSettings.MDC_SCRIPT}${this.site.potentialId}&viewedby=${user}`;
    
    return this.http.get(url, { responseType: 'text' }).subscribe(
    (response: any) => {
      let newResponse: any = JSON.parse(response) || response;
      if (newResponse?.success && newResponse?.data) {
        this.mdcScript = newResponse?.data[0];
        this.mdcScript1 = JSON.parse(this.mdcScript);
        this.initialMDCresponse = this.mdcScript1;
        this.source = newResponse?.data[1];
      }
    },
    (error) => {
      this.toastr.error('Data not found');
      this.initialMDCresponse = null;
    }
    );
    
    this.cdr.detectChanges();
  }

  solarSummary(data){
    let URL = AppSettings.API_ENDPOINT + '/' + AppSettings.SOLAR_SUMMARY;
    const scriptBlob = new Blob([data], { type: 'text/plain' });

    const formData = new FormData();
    formData.append('script', scriptBlob, 'script.txt');
    formData.append('deviceType', this.determineDeviceType());
    this.http.post(URL,formData).subscribe((data)=>{
      this.startDays = data['startDay'],
      this.endDays = data['endDay'],
      this.startTimes = data['startTime'],
      this.endTimes = data['endTime']
    })
  }
  
  updateMDC() {
    if (this.editSolarScript && (this.source?.toUpperCase() == 'DATABASE' || this.source == undefined || this.site.status == 'Not Monitoring')) {
      this.showScript = 'update_script_MDC';
      this.mdc_url = `${AppSettings.API_ENDPOINT}/${AppSettings.MDC_PRE_POPULATE}`;
      const formData = new FormData();
      formData.append('script', new Blob([JSON.stringify(this.mdcScript1)], { type: 'application/json' }), 'script.txt');
      formData.append('deviceType', 'Odriod');
      this.http.post(this.mdc_url, formData).subscribe((data: any) => {
        this.mdc_preData = this.transformMonitoringTimes(data);
        this.backupPreData = JSON.parse(JSON.stringify(this.mdc_preData));
        if (Object.keys(this.mdc_preData).length === 0) {
          this.mdcScript1 = this.mdcPre();
          this.mdc_preData = this.mdcPre()
          this.cdr.detectChanges();
          }
      });
    }
    this.cdr.detectChanges();
  }
  
  
  installBasicGenerate() {
    if (this.editSolarScript && (this.site.status != 'Down' || this.site.status === 'Not Monitoring')) {
      this.previewClick = true;
      this.showScript = 'preview_script';
      let user = this.authService?.currentUserSubject?.value?.email;
      let selectedValue = encodeURIComponent(this.precheckDay);
      this.url = `${AppSettings.API_ENDPOINT}/${AppSettings.GENERATE_SCRIPT}${this.site.potentialId}&deviceType=${this.devicetype}&createdby=${user}&scriptType=basic&startTime='00:00:00'&endTime='23:59:59'&chckday='7'`;
      this.http.get(this.url, { responseType: 'text' }).subscribe((response: any) => {
        this.previewResponse.next(response);
      }, (error) => {
        this.toastr.error('Please try again');
      });
      this.cdr.detectChanges();
    } else if (this.site.status == 'Down') {
      this.toastr.error('Please access when the device is back online');
    }
  }
  
  
  updateGenerate() {
    if ((this.editSolarScript && (this.site.status != 'Down' || this.site.status === 'Not Monitoring'))) {
      this.showScript = 'update_script';
      const updateScript = `${AppSettings.PRE_POPULATE}`;
      
      // Fetch data from local storage if not set
      if (!this.precheckDay && !this.preStartTime && !this.preEndTime && !this.delayFlag) {
        this.precheckDay = localStorage.getItem('precheckDay') || '';
        this.preStartTime = localStorage.getItem('preStartTime') || '';
        this.preEndTime = localStorage.getItem('preEndTime') || '';
        this.delayFlag = localStorage.getItem('delayFlag') === 'true' || false;
      }
      
      const formData = new FormData();
      formData.append('script', new Blob([this.responseData], { type: 'text/plain' }), 'script.txt');
      formData.append('deviceType', this.devicetype);
      const linesToCheck = "LET t1 = 72000";
      this.delayFlag = this.responseData?.includes(linesToCheck.trim());
      
      this.restService.postRequest(updateScript, formData).subscribe((data: any) => {
        if (!data) {
          return;
        }
        // Update class properties and store in local storage
        this.updateData = data;
        this.precheckDay = this.updateData.CheckDay;
        this.preStartTime = this.formattime(this.updateData.StartTime);
        this.preEndTime = this.formattime(this.updateData.EndTime);
        
        this.initialStartTime = this.preStartTime;
        this.initialEndTime = this.preEndTime;
        this.initialCheckdays = this.precheckDay;
        this.initialDelayflag = this.delayFlag;
        
        localStorage.setItem('updateData', JSON.stringify(this.updateData));
        localStorage.setItem('precheckDay', this.precheckDay);
        localStorage.setItem('preStartTime', this.preStartTime);
        localStorage.setItem('preEndTime', this.preEndTime);
        localStorage.setItem('delayFlag', this.delayFlag.toString());
        
        this.cdr.detectChanges();
      }, error => {
        
      });
    } else if (this.site.status == 'Down') {
      this.toastr.error('Please access when the device is back online');
    }
  }
  
  
  delayCheck(): boolean {
    const linesToCheck = "LET t1 = 72000";
    const lineCondition = this.responseData?.includes(linesToCheck.trim());
    const dateCondition = !this.responseData?.includes('date');
    return lineCondition || dateCondition;
  }
  
  basicCheck() {
    const dateCondition = !this.responseData?.includes('date');
    return dateCondition;
  }
  
  isPreviewEnabled(): boolean {
    return !(this.timesNotValid() || (!this.timesChanged(this.preStartTime, this.preEndTime) && !this.dropdownChanged));
  }
  
  
  
  
  deviceType() {
    let devices = this.site.devices;
    if (devices) {
      for (let i = 0; i < devices.length; i++) {
        if (devices[i].type == 'X310') {
          this.devicetype = 'X310';
          this.devPort = devices[i].port;
          this.x310IP = devices[i].vpnIp;
        } else if (devices[i].type == 'X410') {
          this.devicetype = 'X410';
          this.devPort1 = devices[i].port;
          this.x410IP = devices[i].vpnIp;
        } else if (devices[i].deviceName.includes('Odroid')) {
          this.devicetype = 'Odroid';
          this.odroidIP = devices[i].vpnIp;
          this.odroidPort = devices[i].port;
        }
      }
    }
  }
  
  
  scriptFlag() {
      this.cdr.detectChanges();
      if ((this.devicetype == 'X310' || this.devicetype == 'X410')) {
        return this.getMdxScript();
      } else if (this.devicetype === 'Odroid') {
        return this.getMdcScript();
      } else {
        return;
      }
  }
  
  determineDeviceType() {
    let devices = this.site.devices;
    if (devices) {
        for (let i = 0; i < devices.length; i++) {
            if (devices[i].type === 'X310') {  
                return 'X310'; 
            } else if (devices[i].type === 'X410') { 
                return 'X410';
            } 
        }
    }
  }
  
  uploadCheck(): Observable<any>{
    let url = '';
    if (this.devicetype === 'X310') {
      url = `${AppSettings.UPLOAD_CHECK}${this.x310IP}&port=${this.devPort}&potentialId=${this.site.potentialId}&deviceType=${this.devicetype}`
    } else if (this.devicetype === 'X410') {
      url = `${AppSettings.UPLOAD_CHECK}${this.x410IP}&port=${this.devPort1}&potentialId=${this.site.potentialId}&deviceType=${this.devicetype}`
    } 
    return this.restService.postRequest(url,'').pipe(
      tap((data)=>{
        if (data.success == false) {
          setTimeout(()=>{
            window.location.reload();
          },4000)
          this.toastr.error('Device is currently offline. Upload the script once the device is back online','',{ timeOut: 5000 });
          this.spinner.deactivate();
      }
      }), catchError(error=>{
        this.toastr.error('The upload has failed, please try again');
        return of({ success: false });
      })
    )
  }
  
  uploadScript() {
    this.showPreview = false;
    let user = this.authService.currentUserSubject.value.email;
    let url = '';
    let formData = new FormData();
    this.analyticId = this.site?.analyticId;
    const blob = new Blob([this.previewResponse.value], { type: 'text/plain' });
    
    if (this.devicetype === 'X310') {
      url = `${AppSettings.UPLOAD_SCRIPT}${this.site.potentialId}&deviceType=${this.devicetype}&ip=${this.x310IP}&port=${this.devPort}&uploadBy=${user}`;
      formData.append('Scriptflag', 'yes');
    } else if (this.devicetype === 'X410') {
      url = `${AppSettings.UPLOAD_SCRIPT}${this.site.potentialId}&deviceType=${this.devicetype}&ip=${this.x410IP}&port=${this.devPort1}&uploadBy=${user}`;
      formData.append('Scriptflag', '1');
    } else if (this.devicetype === 'Odroid') {
      url = `${AppSettings.MDC_UPLOAD}${this.devicetype}&potentialId=${this.site.potentialId}&uploadBy=${user}&analyticId=${this.analyticId}`;
    }
    formData.append('file', blob, 'script.txt');
    
    this.spinner.activate();
    if (this.devicetype == 'X310' || this.devicetype == 'X410' && this.site.status !== 'Not Monitoring') {
      this.restService.postRequest(url, formData).subscribe((response: any) => {
        this.spinner.deactivate();
        if (response.success == true) {
          this.toastr.success(`${this.devicetype} script updated successfully!`, 'Success');
          window.location.reload();
        } else {
          this.toastr.error('The upload has failed, please try again');
          window.location.reload();
        }
      }, (error) => {
        this.spinner.deactivate();
        this.toastr.error('The upload has failed, please try again.');
        window.location.reload();
      });
    }
    if (this.devicetype == 'X310' || this.devicetype == 'X410' && this.site.status === 'Not Monitoring') {
      this.uploadCheck().subscribe((uploadCheckResponse: any) => { 
          if (uploadCheckResponse.success == true) { 
              this.restService.postRequest(url, formData).subscribe((response: any) => {
                  this.spinner.deactivate();
                  if (response.success) {
                      this.toastr.success(`${this.devicetype} script updated successfully!`, 'Success');
                  } else {
                      this.toastr.error('The upload has failed, please try again');
                  }
                  window.location.reload();
              }, (error) => {
                  this.spinner.deactivate();
                  this.toastr.error('The upload has failed, please try again.');
                  window.location.reload();
              });
          } 
      }); 
  }
    
    if (this.devicetype === 'Odroid') {
      const responseFormat = JSON.stringify(this.previewMDCresponse, null, 2)
      this.restService.postRequest(url, responseFormat).subscribe((response: any) => {
        this.spinner.deactivate();
        if (response.success == true) {
          this.toastr.success(`${this.devicetype} script updated successfully!`, 'Success');
          window.location.reload();
        } else if (response.success == false) {
          this.toastr.error('The upload has failed, please try again.');
          window.location.reload();
        }
      }, (error) => {
        this.spinner.deactivate();
        this.toastr.error('The upload has failed, please try again.');
        window.location.reload();
      });
    }
  }
  
  
  
  cancel(){
    if (!this.initialMDCresponse) {
      this.mdcScript1 = null;
    } else if (!this.initialMDXresponse) {
      this.responseData = null;
    }
    switch (this.showScript) {
      case 'preview_script':
      if(this.selectedScript1 === '1'){
        this.showScript = 'show_script';
      } else {
        this.showScript = 'update_script';
      }
      // Retrieve values from local storage
      this.precheckDay = localStorage.getItem('precheckDay') || '';
      this.preStartTime = localStorage.getItem('preStartTime') || '';
      this.preEndTime = localStorage.getItem('preEndTime') || '';
      this.delayFlag = localStorage.getItem('delayFlag')  === 'true';
      break;
      case 'preview_script_MDC':
      this.showScript = 'update_script_MDC';
      break;
      case 'update_script':
      this.showScript = 'show_script';
      break;
      case 'update_script_MDC':
      this.showScript = 'show_script';
      this.showScript = 'show_script';
      break;
      case 'basic_preview':
      this.showScript = 'show_script';
    }
    if (!this.precheckDay) {
      this.precheckDay = this.initialCheckdays;
    }
    if (!this.preStartTime) {
      this.preStartTime = this.initialStartTime;
    }
    if (!this.preEndTime) {
      this.preEndTime = this.initialEndTime;
    }
    if(!this.delayFlag){
      this.delayFlag = this.initialDelayflag;
    }
    this.isChecked = this.delayFlag;
    this.dropdownChanged = false;
    this.mdc_preData = JSON.parse(JSON.stringify(this.backupPreData));
    for(const day of this.orderedDays) {
      this.inputTimes[day].morningStart = null;
      this.inputTimes[day].morningEnd = null;
      this.inputTimes[day].eveningStart = null;
      this.inputTimes[day].eveningEnd = null;
    }
  }
  
  getMonitoringEnd(day: string): string {
    return this.mdc_preData[day?.toLowerCase()]?.[0]?.monitoringEnd;
  }
  
  getMonitoringStart(day: string): string {
    return this.mdc_preData[day?.toLowerCase()]?.[1]?.monitoringStart || '';
  }
  
  getMonitoringEndForSecond(day: string): string {
    return this.mdc_preData[day?.toLowerCase()]?.[1]?.monitoringEnd || '';
  }

  mdcPre(){
    this.mdc_preData = {
      "monday": [
        {"monitoringStart": "00:00", "monitoringEnd": "23:59"}
      ],
      "tuesday": [
        {"monitoringStart": "00:00", "monitoringEnd": "23:59"}
      ],
      "wednesday": [
        {"monitoringStart": "00:00", "monitoringEnd": "23:59"}
      ],
      "thursday": [
        {"monitoringStart": "00:00", "monitoringEnd": "23:59"}
      ],
      "friday": [
        {"monitoringStart": "00:00", "monitoringEnd": "23:59"}
      ],
      "saturday": [
        {"monitoringStart": "00:00", "monitoringEnd": "23:59"}
      ],
      "sunday": [
        {"monitoringStart": "00:00", "monitoringEnd": "23:59"}
      ]
    }
    return this.mdc_preData;
  }
  
  is24HrChecked(day:string){
    const data = this.mdc_preData[day?.toLowerCase()];
    if(data[0]?.monitoringEnd === '23:59'){
      return true
    } else {
      return false
    }
  }
  
  on24HrCheckboxChange(isChecked: boolean, day: string): void {
    if (isChecked) {
      this.inputTimes[day].morningStart = '00:00';
      this.inputTimes[day].morningEnd = '23:59';
      this.inputTimes[day].eveningStart = '';
      this.inputTimes[day].eveningEnd = '';
    } else {
      this.inputTimes[day].morningStart = '';
      this.inputTimes[day].morningEnd = '';
      this.inputTimes[day].eveningStart = '';
      this.inputTimes[day].eveningEnd = '';
    }
  }
  
  toggle24Hr(day: string, event: any): void {
    this.cdr.detectChanges();
    this.checked = event.checked;
    const data = this.mdc_preData[day?.toLowerCase()];
    if(event.checked){
      this.originalValues[day] = {
        monitoringStart1: data[0]?.monitoringStart,
        monitoringEnd1: data[0]?.monitoringEnd,
        monitoringStart2: data[1]?.monitoringStart,
        monitoringEnd2: data[1]?.monitoringEnd
      };
      if(data && data.length >=2){
        data[0].monitoringStart = '00:00';
        data[0].monitoringEnd = '23:59';
        data[1].monitoringStart = null;
        data[1].monitoringEnd = null;
      }
    }
    else {
      if (data && data.length >= 2) {
        data[0].monitoringStart = this.originalValues[day].monitoringStart1 || '';
        data[0].monitoringEnd = this.originalValues[day].monitoringEnd1 || '';
        data[1].monitoringStart = this.originalValues[day].monitoringStart2 || '';
        data[1].monitoringEnd = this.originalValues[day].monitoringEnd2 || '';    }
      }
    }
    
    timesNotValid(): boolean {
      
      if (this.preStartTime?.split(':').length === 2) {
        this.startTime = `${this.preStartTime}:00`;
      } else {
        this.startTime = this.preStartTime;
      }
      
      if (this.preEndTime?.split(':').length === 2) {
        this.endTime = `${this.preEndTime}:00`;
      } else {
        this.endTime = this.preEndTime;
      }
      
      return this.startTime >= this.endTime;
    }
    
    previewScript():Observable<any> {
      this.previewClick = true;
      this.isCheckedDelay = false;
      this.showScript = 'preview_script';
      let user = this.authService.currentUserSubject.value.email;
      let selectedValue = encodeURIComponent(this.precheckDay);
      this.url = `${AppSettings.API_ENDPOINT}/${AppSettings.GENERATE_SCRIPT}${this.site.potentialId}&deviceType=${this.devicetype}&createdby=${user}&scriptType=yes&startTime=${this.startTime}&endTime=${this.endTime}&chckday=${selectedValue}`;
      this.http.get(this.url,{ responseType: 'text' }).subscribe((response:any)=>{
        this.previewResponse.next(response);
        this.cdr.detectChanges();
      },(error)=>{
      })
      return new Observable((observer) => {
        this.http.get(this.url, { responseType: 'text' }).subscribe((response: any) => {
          this.previewResponse.next(response);
          this.cdr.detectChanges();
          observer.next(response);
          observer.complete();
        }, (error) => {
          observer.error(error);
        });
      });
    }
    
    delayHrs() {
      let url = `${AppSettings.API_ENDPOINT}/${AppSettings.DELAY_2HRS}`;
      this.previewClick = true;
      this.showScript = 'preview_script';
      
      this.previewScript().subscribe((scriptResponse) => {
        const formData = new FormData();
        this.cdr.detectChanges();
        formData.append('script', new Blob([scriptResponse], { type: 'text/plain' }), 'script.txt');
        formData.append('deviceType', this.devicetype);
        
        this.http.post(url, formData, { responseType: 'text' }).subscribe((response: any) => {
          this.previewResponse.next(response);
          this.cdr.detectChanges();
        }, (error) => {
        });
      }, (error) => {
      });
    }
    
    
    checkboxToggled(event: any) {
      this.isChecked = event.checked;
    }
    
    handleButtonClick() {
      if((!this.basicCheck() && !this.delayFlag) || this.basicCheck()){
        this.previewScript();
      } else if((!this.basicCheck() && this.delayFlag)){
        this.delayHrs();
      }
    }
    
    setMonitoringData(day: string, type: 'start' | 'end', value: string) {
      const dayKey = day?.toLowerCase();
      
      if (!this.mdc_preData[dayKey]) {
        this.mdc_preData[dayKey] = [];
      }
      
      if (!this.mdc_preData[dayKey][1]) {
        this.mdc_preData[dayKey][1] = {};
      }
      
      if (type === 'start') {
        this.mdc_preData[dayKey][1].monitoringStart = value;
      } else if (type === 'end') {
        this.mdc_preData[dayKey][1].monitoringEnd = value;
      }
    }
    
    convertDataFormat(data) {
      let convertedData = {};
      for (let day in data) {
        let dayKey = day.toLowerCase();
        convertedData[dayKey] = data[day].map(interval => ({
          monitoringStart: interval.monitoringStart,
          monitoringEnd: interval.monitoringEnd
        }));
      }
      return convertedData;
    }
    
    previewMDC(){
      this.cdr.detectChanges();
      this.previewClick = true;
      this.showScript = 'preview_script_MDC';
      let user = this.authService.currentUserSubject.value.email;
      this.url = `${AppSettings.API_ENDPOINT}/${AppSettings.MDC_UPDATE}${this.site.potentialId}&deviceType=${this.devicetype}&createdby=${user}&scriptType=y`;
      if(this.mdcScript1){
        this.cdr.detectChanges();
        let validationResult = this.validateTimes();
        if (!validationResult.isValid) {
          this.toastr.error(validationResult.message, 'Invalid Time');
          this.showScript = 'update_script_MDC';
          this.cdr.detectChanges();
          return;
        }
        this.mdcPayload = this.mdc_preData;
        this.http.post(this.url,this.mdcPayload).subscribe((response:any)=>{
          response.solarInfo.exceptionDays.forEach(day => {
            day.date = day.date.trim();
          });
          this.previewMDCresponse = this.modifyMonitoringTimes(response);
          this.cdr.detectChanges();
        },(error)=>{
        });
      } else if(!this.mdcScript1){
        this.cdr.detectChanges();
        let hasNullValues = false;
        let invalidTime = false;
        this.requestData = [];
        const isTimeValid = (morningStart: string, morningEnd: string, eveningStart: string, eveningEnd: string) : { isValid: boolean, message?: string }=> {
          const [mStartHr, mStartMin] = morningStart.split(':').map(Number);
          const [mEndHr, mEndMin] = morningEnd.split(':').map(Number);
          const [eStartHr, eStartMin] = eveningStart.split(':').map(Number);
          const [eEndHr, eEndMin] = eveningEnd.split(':').map(Number);
          
          if (mEndHr * 60 + mEndMin <= mStartHr * 60 + mStartMin) {
            return { isValid: false, message: `Morning end time should be greater than Morning start time` };
          }
          if (eStartHr * 60 + eStartMin <= mEndHr * 60 + mEndMin) {
            return { isValid: false, message: `Evening start time should be greater than Morning end time` };
          }
          
          if (eEndHr * 60 + eEndMin <= eStartHr * 60 + eStartMin) {
            return { isValid: false, message: `Evening end time should be greater than Evening start time` };
          }
          
          return { isValid: true };
        }
        
        for (const day of this.orderedDays) {
          const dayTimes = this.inputTimes[day];
          this.checkboxStates[day] = false;
          if (dayTimes.morningStart === '00:00' &&
          dayTimes.morningEnd === '23:59' &&
          dayTimes.eveningStart === '' &&
          dayTimes.eveningEnd === '') {
            
            this.requestData[day] = [
            {
              monitoringStart: "00:00:01",
              monitoringEnd: "23:59:59"
            }
            ];
          } else {
            if (
            dayTimes.morningStart === null ||
            dayTimes.morningEnd === null ||
            dayTimes.eveningStart === null ||
            dayTimes.eveningEnd === null
            ) {
              hasNullValues = true;
              this.showScript = 'update_script_MDC';
              break;
            }
            const validationResult = isTimeValid(dayTimes.morningStart, dayTimes.morningEnd, dayTimes.eveningStart, dayTimes.eveningEnd);
            if (!validationResult.isValid) {
              this.toastr.error(validationResult.message, 'Error');
              this.showScript = 'update_script_MDC';
              this.cdr.detectChanges();
              return;
            }
            this.requestData[day] = [
            {
              monitoringStart: dayTimes.morningStart+':'+'01',
              monitoringEnd: dayTimes.morningEnd +':'+'00'
            },
            {
              monitoringStart: dayTimes.eveningStart+':'+'00',
              monitoringEnd: dayTimes.eveningEnd === '23:59' ? dayTimes.eveningEnd + ':59' : dayTimes.eveningEnd + ':00'
            }
            ];
          }
        }
        if (hasNullValues) {
          this.toastr.error('All time fields must be filled before submitting', 'Error');
        } else if (invalidTime) {
          this.toastr.error('Invalid time ranges provided. Please check and try again.', 'Error');
        }
        this.http.post(this.url,this.convertDataFormat(this.requestData)).subscribe((response:any)=>{
          this.previewMDCresponse = response;
          this.cdr.detectChanges();
        },(error)=>{
        })
      }
    }
    
    
    onTimeChange(time: string, day: string, index: number, key: string) {
      const lowerDay = day?.toLowerCase();
      if (!lowerDay) return;
      if (!this.mdc_preData[lowerDay]) {
        this.mdc_preData[lowerDay] = [{}, {}];
      }
      
      const formattedTime = time === '00:00:01' ? '00:00' : time;
      this.mdc_preData[lowerDay][index][key] = formattedTime;
    }
    
    
    transformMonitoringTimes(response: any): any {
      const trimStrings = (obj: any) => {
        for (let key in obj) {
          if (obj.hasOwnProperty(key)) {
            if (typeof obj[key] === 'object') {
              trimStrings(obj[key]);
            } else if (typeof obj[key] === 'string' && obj[key].length > 2) {
              obj[key] = obj[key].substring(0, obj[key].length - 3);
            }
          }
        }
      };
      
      trimStrings(response);
      return response;
    }
    
    
    validateTimes() {
      if (!this.orderedDays || !this.mdc_preData) {
        return { isValid: false, message: "Days or times data is missing" };
      }
      for (const day of this.orderedDays) {
        if (this.is24HrChecked(day)) {
          continue;
        }
        const dayKey = day.toLowerCase();
        if (!this.mdc_preData[dayKey] || this.mdc_preData[dayKey].length < 2) {
          return { isValid: false, message: `${day} has incomplete time data` };
        }
        
        for (const time of this.mdc_preData[dayKey]) {
          if (time.monitoringStart === "" || time.monitoringEnd === "") {
            return { isValid: false, message: `${day}: Monitoring times cannot be empty` };
          }
        }
        
        for (const time of this.mdc_preData[dayKey]) {
          if (time.monitoringStart === "" || time.monitoringEnd === "") {
            return { isValid: false, message: `${day}: Monitoring times cannot be empty` };
          }
        }
        
        let morningStart = new Date(`1970-01-01T${this.mdc_preData[dayKey][0].monitoringStart}`);
        let morningEnd = new Date(`1970-01-01T${this.mdc_preData[dayKey][0].monitoringEnd}`);
        let eveningStart = new Date(`1970-01-01T${this.mdc_preData[dayKey][1].monitoringStart}`);
        let eveningEnd = new Date(`1970-01-01T${this.mdc_preData[dayKey][1].monitoringEnd}`);
        
        if (morningEnd <= morningStart) {
          return { isValid: false, message: `${day}: Morning end time should be greater than Morning start time` };
        }
        if (eveningStart <= morningEnd) {
          return { isValid: false, message: `${day}: Evening start time should be greater than Morning end time` };
        }
        if (eveningEnd <= eveningStart) {
          return { isValid: false, message: `${day}: Evening end time should be greater than Evening start time` };
        }
      }
      return { isValid: true, message: "All times are valid" };
    }
    
    
    modifyMonitoringTimes(response: any) {
      const formatTime = (time: string, isStart: boolean) => {
        if (isStart && time === '00:00') return time + ':01';
        if (!isStart && time === '23:59') return time + ':59';
        return time + ':00';
      };
      
      const traverseDays = (dayObj: any) => {
        for (const dayKey in dayObj) {
          const day = dayObj[dayKey];
          if (day.times) {
            day.times.forEach((timeObj: any) => {
              if (timeObj.monitoringStart?.includes('undefined')) timeObj.monitoringStart = null;
              if (timeObj.monitoringEnd?.includes('undefined')) timeObj.monitoringEnd = null;
              if (timeObj.monitoringStart) {
                timeObj.monitoringStart = formatTime(timeObj.monitoringStart, true);
              }
              if (timeObj.monitoringEnd) {
                timeObj.monitoringEnd = formatTime(timeObj.monitoringEnd, false);
              }
            });
            day.times = day.times.filter((timeObj: any) => timeObj.monitoringStart && timeObj.monitoringEnd);
          }
        }
      };
      
      response.solarInfo.weekdays.forEach(traverseDays);
      return response;
    }
    
    checkboxToggledBasic(event: any) {
      if (event.checked) {
        this.delayHrs();
      } else {
        this.previewScript();
      }
    }
    
    getTicketHistory() {
      let url = `${AppSettings.TICKETDETAILS}siteId=${this.site.unitId}&potentialId=${this.site.potentialId}`
      this.thistoryData = [];
      this.loading = true;
      this.spinner.activate();
      this.restService.getData(url).subscribe((response) => {
        if (response) {
          
          function compareDates(dateStrA, dateStrB) {
            const dateA = new Date(dateStrA);
            const dateB = new Date(dateStrB);
            return dateB.getTime() - dateA.getTime();
          }
          
          const formattedData = response.map((item) => ({
            ...item,
            createDate: this.formatHistoryDate(item.createDate)
          }));
          
          formattedData.sort((a, b) => compareDates(a.createDate, b.createDate));
          
          this.thistoryData = formattedData;
          this.cdr.detectChanges();
        } else {
          this.toastr.error('Data not found');
        }
        this.spinner.deactivate();
        this.loading = false;
      }, (err) => {
        this.spinner.deactivate();
        this.loading = false;
        if (err && err.error && err.error.message && err.error.message.length > 0) {
          this.toastr.error(err.error.message, 'Error');
        } else {
        }
        this.spinner.deactivate();
        this.loading = false;
      });
    }
    
    timesChanged(startTime: any, endTime: any):boolean {
      if(this.startTime !== this.initialStartTime || this.endTime !== this.initialEndTime){
        return true;
      }
    }
    
    checkChange(checkDay:any){
      if (checkDay !== this.initialCheckdays) {
        this.dropdownChanged = true;
      } else {
        this.dropdownChanged = false;
      }
    }
    
    scriptHistory() {
      let url = AppSettings.SCRIPT_HISTORY + this.site.potentialId;
      this.restService.getData(url).subscribe((response:any)=>{
        this.scripthistory = response.sort((a, b) => {
          const dateA = new Date(a.lastModifiedDate);
          const dateB = new Date(b.lastModifiedDate);
          return dateB.getTime() - dateA.getTime();
        });
      })
    }
    
    viewScript(script: string) {
      this.selectedScript = script;
      this.isModalOpen = true;
    }
    
    onCloseModal() {
      this.isModalOpen = false;
    }
    
    formatHistoryDate(dateString) {
      if (dateString) {
        const dateParts = dateString.split('-');
        if (dateParts && dateParts.length === 3) {
          const formattedDate = `${dateParts[1]}-${dateParts[2]}-${dateParts[0]}`;
          return formattedDate;
        }
      }
      return null;
    }
    
    formatdate(dateTimeString: string): string {
      const dateObj = new Date(dateTimeString);
      const dd = String(dateObj.getDate()).padStart(2, '0');
      const mm = String(dateObj.getMonth() + 1).padStart(2, '0');
      const yyyy = dateObj.getFullYear();
      const hours = String(dateObj.getHours()).padStart(2, '0');
      const minutes = String(dateObj.getMinutes()).padStart(2, '0');
      const seconds = String(dateObj.getSeconds()).padStart(2, '0');
      
      return `${mm}-${dd}-${yyyy}  ${hours}:${minutes}:${seconds}`;
    }
    
    formattime(apiTime: string): string {
      if (apiTime) {
        const parts = apiTime.split(':');
        const hours = parts[0].padStart(2, '0');
        const minutes = parts[1].padStart(2, '0');
        const seconds = parts[2].padStart(2, '0');
        return `${hours}:${minutes}:${seconds}`;
      }
    }
    
    lastChange(){
      let url = `${AppSettings.LAST_CHANGE}${this.site.potentialId}`
      this.restService.getData(url).subscribe((response)=>{
        this.lastModifiedBy = response.lastModifiedBy;
        this.lastModifiedAt = response.lastModifiedDate;
      })
    }
    
    showPopup(name,status,ticket,link){
      this.deviceNames = name;
      this.deviceStatus = status;
      this.ticket = ticket;
      this.ticketLink = link;
      this.popupVisible = true;
    }
    
    hidePopup() {
      this.popupVisible = false;
    }
    
    ngAfterViewInit(): void {
      const siteframe = document.getElementById("ifr") as HTMLIFrameElement;
      siteframe.src = this.url;
      //var weatherurl = "https://dev-grafana.pro-vigil.info:3000/d/gnc3kSJnz/weather-metrics?kiosk&from=" + this.fromDate + "&to=" + this.toDate + "&orgId=1&var-job=node_exporter&var-nodename=" + this.site.potentialId + "&var-node=" + this.site.ipaddress;
      var weatherurl = this.grafanaData.weatherUrl + this.weatherFromDt + "&to=" + this.toDate + "&orgId=1&var-job=node_exporter&var-nodename=" + this.site.potentialId + "&var-unitId=" + this.site.unitId;
      this.camurls = [];
      this.getWeatherdata();
      this.tabGroup.selectedIndex = 2;
    }
    
    ngOnChanges(changes: SimpleChanges) {
      if (changes.preEndTime && this.preEndTime) {
        const parts = this.preEndTime.split(':');
        if (parts.length === 3) {
          this.preEndTime = parts[0] + ':' + parts[1] + ':00';
        }
      }
    }
    
    /**
    * Sort Items based on asc/dsc
    * @param key
    */
    sortItems(key: any) {
      if (this.ascDsc) {
        this.networkData = this.networkData.sort((a, b) => {
          if (a[key] === undefined || a[key] === null) return 1;
          if (b[key] === undefined || b[key] === null) return -1;
          if (a[key] === b[key]) return 0;
          let aVal:string = (a[key].toString()).trim();
          let bVal:string = (b[key].toString()).trim();
          return aVal.toLowerCase() < bVal.toLowerCase() ? -1 : 1;
        });
      } else {
        this.networkData = this.networkData.sort((a, b) => {
          if (a[key] === undefined || a[key] === null) return 1;
          if (b[key] === undefined || b[key] === null) return -1;
          if (a[key] === b[key]) return 0;
          let aVal:string = (a[key].toString()).trim();
          let bVal:string = (b[key].toString()).trim();
          return aVal.toLowerCase() > bVal.toLowerCase() ? -1 : 1;
        });
      }
      this.ascDsc = !this.ascDsc;
    }
    
    sortItems1(key: any) {
      if (this.ascDsc) {
        const siteDevices = this.site.devices;
        this.siteData = siteDevices.sort((a, b) => {
          if (a[key] === undefined || a[key] === null) return 1;
          if (b[key] === undefined || b[key] === null) return -1;
          if (key === 'port') {
            let aPort = typeof a[key] === 'string' ? parseInt(a[key]) : a[key];
            let bPort = typeof b[key] === 'string' ? parseInt(b[key]) : b[key];
            return aPort - bPort;
          }
          if (a[key] === b[key]) return 0;
          let aVal:string = (a[key].toString()).trim();
          let bVal:string = (b[key].toString()).trim();
          return aVal.toLowerCase() < bVal.toLowerCase() ? -1 : 1;
        });
      } else {
        this.siteData = this.siteData.sort((a, b) => {
          if (a[key] === undefined || a[key] === null) return 1;
          if (b[key] === undefined || b[key] === null) return -1;
          if (key === 'port') {
            let aPort = typeof a[key] === 'string' ? parseInt(a[key]) : a[key];
            let bPort = typeof b[key] === 'string' ? parseInt(b[key]) : b[key];
            return bPort - aPort;
          }
          if (a[key] === b[key]) return 0;
          let aVal:string = (a[key].toString()).trim();
          let bVal:string = (b[key].toString()).trim();
          return aVal.toLowerCase() > bVal.toLowerCase() ? -1 : 1;
        });
      }
      this.ascDsc = !this.ascDsc;
    }
    
    daysFilter(event?: Event) {
      let filterValue = this.filterValue;
      if (this.filterValue === 'custom') {
        const epochTo = (new Date(this.end)).getTime();
        const epochFrom = (new Date(this.start)).getTime();
        this.toDate = epochTo ? epochTo : '';
        this.fromDate = epochFrom ? epochFrom : '';
        this.toDateCustom = new Date(this.toDate);
        this.fromDateCustom = new Date(this.fromDate);
      } else {
        this.start = '';
        this.end = '';
        const epochTo = (new Date()).getTime();
        let minusVal = 1000 * 60 * 60 * 24 * filterValue;
        if (filterValue == 1) {
          this.step = "1h";
        }
        else {
          this.step = "1d";
        }
        const epochFrom = epochTo - minusVal;
        this.toDate = epochTo;
        this.fromDate = epochFrom;
      }
      
      if (this.tabGroup.selectedIndex == 0) {
        if (this.siteTabGroup.selectedIndex == 0) {
          this.url = this.grafanaData.sitesUrl + this.step + "&from=" + this.fromDate + "&to=" + this.toDate + "&var-job=Pushgateway&var-name=" + this.site.siteId + `&panelId=${environment.env == 'uat' ? 1 : 2}`;
          const siteframe = document.getElementById("ifr") as HTMLIFrameElement;
          siteframe.src = this.url;
        }
        // if (this.siteTabGroup.selectedIndex == 2) {
          //  // var weatherurl = this.grafanaData.weatherUrl + this.fromDate + "&to=" + this.toDate + "&orgId=1&refresh=1h&var-job=node_exporter&var-nodename=" + this.site.potentialId + "&var-node=" + this.site.ipaddress;
          //   const iframe = document.getElementById("ifrweather") as HTMLIFrameElement;
          //   //const iframe = this.hostElement.nativeElement.querySelector('iframe[id='+cam.deviceId+']');
          //   iframe.src = weatherurl;
          // }
          
          if (this.siteTabGroup.selectedIndex == 2) {
            //var cpuUrl = "https://dev-grafana.pro-vigil.info:3000/d/9foo6PJ7k/site-metrics-nodeexporter?kiosk&orgId=1&var-nodename=" + this.site.unitId + "&var-job=node_exporter&var-node=" + this.site.ipaddress + "&from=" + this.fromDate + "&to=" + this.toDate
            var cpuUrl = this.grafanaData.statsUrl + this.site.unitId + "&var-job=node_exporter&var-node=" + this.site.ipaddress + "&from=" + this.fromDate + "&to=" + this.toDate;
            const iframe = document.getElementById("ifrcpu") as HTMLIFrameElement;
            //const iframe = this.hostElement.nativeElement.querySelector('iframe[id='+cam.deviceId+']');
            iframe.src = cpuUrl;
          }
        }
        if (this.tabGroup.selectedIndex == 1) {
          for (const cam of this.cams) {
            // var camurl = "https://dev-grafana.pro-vigil.info:3000/d-solo/YW4-S3Jnk/profit-monitors?orgId=1&var-job=Pushgateway&refresh=" + this.step + "&from=" + this.fromDate + "&to=" + this.toDate + "&var-name=" + cam.deviceId + "&panelId=2";
            var camurl = this.grafanaData.deviceUrl + this.step + "&from=" + this.fromDate + "&to=" + this.toDate + "&var-name=" + cam.deviceId + `&panelId=${environment.env == 'uat' ? 1 : 2}`;
            const iframe = document.getElementById(cam.deviceId) as HTMLIFrameElement;
            //const iframe = this.hostElement.nativeElement.querySelector('iframe[id='+cam.deviceId+']');
            iframe.src = camurl;
          }
        }
        
        
      }
      
      /* transform(url) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
      }*/
      
      selectedTabValue(event) {
        this.sitetablabel = "";
        if (event.index == 3 && !this.isGraphLoaded) {
          const myDiv = document.getElementById('myChart');
          const toggleDiv = document.getElementById('toggle');
          const BUTTON = document.getElementById('toggleId');
          myTest(this.data, myDiv, 1024, 4000);
          this.isGraphLoaded = true;
          this.loader = false;
          
          if (BUTTON !== null) {
            BUTTON.addEventListener('click', function () {
              document.getElementById("toggle").requestFullscreen();
            })
          }
        }
        this.labelName = event.tab.textLabel;
        if(this.labelName == "Site Dashboard" || this.labelName == "Devices"){
          this.isFilter = true;
        } else {
          this.isFilter = false;
        }
        if (this.labelName == "Devices") {
          for (const cam of this.cams) {
            // var camurl = "https://dev-grafana.pro-vigil.info:3000/d-solo/YW4-S3Jnk/profit-monitors?orgId=1&var-job=Pushgateway&refresh=" + this.step + "&from=" + this.fromDate + "&to=" + this.toDate + "&var-name=" + cam.deviceId + "&panelId=2";
            //  this.camurls.push(camurl);
            var camurl = this.grafanaData.deviceUrl + this.step + "&from=" + this.fromDate + "&to=" + this.toDate + "&var-name=" + cam.deviceId + `&panelId=${environment.env == 'uat' ? 1 : 2}`;
            const iframe = document.getElementById(cam.deviceId) as HTMLIFrameElement;
            //const iframe = this.hostElement.nativeElement.querySelector('iframe[id='+cam.deviceId+']');
            iframe.src = camurl;
            
          }
        } else {
          this.setTabUrl(this.sitetablabel);
        }
      }
      
      siteTabSelected(event) {
        this.sitetablabel = event.tab.textLabel;
        this.setTabUrl(this.sitetablabel);
        if(event.index==1){
          this.isperformanceEnabled=true;
        } else {
          this.isperformanceEnabled=false;
        }
      }
      setTabUrl(sitetablabel) {
        if (sitetablabel == "Weather") {
          // var weatherurl = "https://dev-grafana.pro-vigil.info:3000/d/gnc3kSJnz/weather-metrics?kiosk&orgId=1&from=now-24h&to=now&refresh=1h&var-job=node_exporter&var-nodename=F1042&var-node=10.76.2.164";
          // var weatherurl = this.grafanaData.weatherUrl + this.weatherFromDt + "&to=" + this.toDate + "&orgId=1&refresh=1h&var-job=node_exporter&var-nodename=" + this.site.potentialId + "&var-unitId=" + this.site.unitId;
          
          // const iframe = document.getElementById("ifrweather") as HTMLIFrameElement;
          //const iframe = this.hostElement.nativeElement.querySelector('iframe[id='+cam.deviceId+']');
          // iframe.src = weatherurl;
        }
        
        if (sitetablabel == "Status") {
          const siteframe = document.getElementById("ifr") as HTMLIFrameElement;
          if(siteframe){
            this.url = this.grafanaData.sitesUrl + this.step + "&from=" + this.fromDate + "&to=" + this.toDate + "&var-job=Pushgateway&var-name=" + this.site?.siteId + `&panelId=${environment.env == 'uat' ? 1 : 2}`;
            siteframe.src = this.url;
          }
        }
        if (sitetablabel == "Stats Metrics") {
          var cpuUrl = this.grafanaData.statsUrl + this.site.unitId + "&var-job=node_exporter&var-node=" + this.site.ipaddress + "&from=" + this.fromDate + "&to=" + this.toDate
          //this.url = "https://dev-grafana.pro-vigil.info:3000/d-solo/avszAyAnk/profit-sites?orgId=1&refresh=" + this.step + "&from=" + this.fromDate + "&to=" + this.toDate + "&var-job=Pushgateway&var-name=" + this.site.siteId + "&panelId=2";
          const siteframe = document.getElementById("ifrcpu") as HTMLIFrameElement;
          siteframe.src = cpuUrl;
        }
        
        if (sitetablabel == 'Tickets History (Last 90 days)') {
          this.getTicketHistory();
        }

        if(sitetablabel == "Weather" || sitetablabel == "Stats Metrics" || sitetablabel == "Tickets History (Last 90 days)" || sitetablabel == "Monitoring Hours"){
          this.isFilter = false;
        } else if(sitetablabel == "Status" || sitetablabel == "Performance Dashboard"){
          this.isFilter = true;
        }
        
      }

      getWeatherForcast(){
        let url = AppSettings.FORECAST + this.site?.potentialId
        this.restService.getRequest(url,'').subscribe((response)=>{
          this.forecastWeather = response;
          this.forcastDays = response.data.days;
          this.forcastTemp = response.data.temp;
        })
      }
      
      selectTab(tab: number) {
        this.selectedTab = tab;
        this.previewScript()
        this.scriptHistory()
      }
      
      //----------------------------------------------------------------------------------------------------
      // code for Zoom
      //----------------------------------------------------------------------------------------------------
      
      zoomToggle(zoomIn: boolean) {
        if (zoomIn) {
          if (this.zoom < 1.3) {
            this.zoom += 0.1;
          }
        } else {
          if (this.zoom > 0.7) {
            this.zoom -= 0.1;
          }
        }
        let zoomEle = this.chartContainer.nativeElement;
        zoomEle.style.transform = 'scale(' + this.zoom + ')';
      }
      
      showModal(el:any){
        this.masking_cameradayImg = el.dayImage ? el.dayImage : '../../../../assets/imgs/Image_not_available.png';
        this.masking_nightimage = el.nightImage ? el.nightImage : '../../../../assets/imgs/Image_not_available.png';
        this.camName = el.deviceName;
        this.show = !this.show;
      }
      modelChangeFn(value) {
        this.notEdited=false;
      }

      showCameraData(data:any){
          var clonedObj:any ={};
          let url = AppSettings.API_ENDPOINT + '/' + AppSettings.CAM_INFO_UNIQUE + data;
          this.http.get(url).subscribe(dt=>{
          this.cameraMetadata = dt;
          for (const key in this.cameraMetadata) {
            if (Object.hasOwnProperty.call(this.cameraMetadata, key)) {
              const newKey = key.replace(/\./g, '_');
              clonedObj[newKey] = this.cameraMetadata[key];
            }
          }
          this.cameraMeta = clonedObj.data;
          this.cdr.detectChanges();
          let ele = document.getElementById('modelCam') as HTMLElement;
          if(ele){
            ele.style.display = 'block';
          }   
        })
      }
    
      closeCameraPopup(){
        let ele = document.getElementById('modelCam') as HTMLElement;
        if(ele){
          ele.style.display = 'none';
        }
      }

      showMdcdata(data){
        this.spinner.activate()
        this.restService.getRequest(AppSettings.MDC_DEVICES,'').subscribe((dt)=>{
          this.spinner.deactivate()
          this.mdcMetadata = dt.filter(x=> x.deviceUqId == data.deviceUqId);
          this.mdcMetadata = this.mdcMetadata[0];
          this.cdr.detectChanges();
          let ele = document.getElementById('modelMdc') as HTMLElement;
          if(ele){
            ele.style.display = 'block';
          }
        })
      }

      closeMdcdata(){
        let ele = document.getElementById('modelMdc') as HTMLElement;
        if(ele){
          ele.style.display = 'none';
        }
        this.spinner.deactivate()
      }


      
      showRouterdata(data){
        this.showRouterData = true
        this.spinner.activate();
        let url = `${AppSettings.ROUTER_INFO}${data.vpnIp}`
        this.restService.getRequest(url,'').subscribe((response)=>{
          this.spinner.deactivate();
          this.routerInfo = response;
          this.cdr.detectChanges();
          let ele = document.getElementById('modelRouter') as HTMLElement;
          if(ele){
            ele.style.display = 'block';
          }
        })
      }

      closeRouterInfo(){
        let ele = document.getElementById('modelRouter') as HTMLElement;
        if(ele){
          ele.style.display = 'none';
        }
      }
      
}
